// extracted by mini-css-extract-plugin
module.exports = {"container":"SnapshotMemberItem_container__3DOAI"};